import { useApiConfigStore } from "@store/api_config";

/**
 * Build the URL to the backend vehicle-image endpoint.
 * The backend handles caching in GCS and fetching from imagin.studio if needed.
 */
export function getVehicleImageUrl(
  marque?: string,
  modele?: string,
  coloris?: string,
  mec?: number,
): string | null {
  if (!marque || !modele) return null;

  const baseUrl = useApiConfigStore.getState().getApiUrl();
  const params = new URLSearchParams({
    make: marque,
    model: modele,
    color: coloris || "gris",
  });
  // NOTE: `mec`/year is intentionally NOT sent. imagin.studio falls back to a
  // current body (a van) for older models when a year is supplied, and keeping it
  // in the URL also kept the wrong image in the browser cache.

  return `${baseUrl}/public/vehicle-image?${params.toString()}`;
}
